import clsx from 'clsx';
import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import TicketIcon from '@/icons/TicketIcon';
import { Preloader } from '@/nikeone/components/TournamentList';
import useExpander from '@/_hooks/useExpander';
import { HybridTourContent } from '@/nikeone/components/TournamentContent';
import i18n from '@i18n';
import { loadOnTickets } from '@/nikeone/handlers';
import { activeSportEventIds } from '@/mytickets/active/subs';
import { AccordionArrow } from '@/common/components/Accordion';

function TournamentsOnTickets({ slug, favs }) {
    const [stateExpanded, onToggle] = useExpander();
    const derefSub = useReframe();
    const mark = derefSub(activeSportEventIds).count();
    useEffect(() => dispatch(loadOnTickets('filteredBoxStore', slug)), [slug, mark]);
    let matchesCount = derefSub(['nikeone/matchCountOnTickets', 'filteredBoxStore', 'onTicketsBoxId']);
    return (
        <div className={clsx('accordion', { active: stateExpanded, onTicket: !favs })} data-atid="accordion">
            <Preloader boxId="onTicket" />
            <h1 className="accordion-head flex items-center" onClick={onToggle}>
                <div className="star-button mx-5 ripple">
                    <TicketIcon height={16} width={16} fill="#ff8000" />
                </div>
                <span>{i18n('filter.title.ticketsOnly')}</span>
                <label>{matchesCount ? matchesCount : '0'}</label>
                <AccordionArrow expanded={stateExpanded} />
            </h1>
            {stateExpanded !== true && stateExpanded !== false ? null : (
                <div style={{ display: stateExpanded ? 'block' : 'none' }}>
                    {matchesCount ? (
                        <HybridTourContent
                            boxStore="filteredBoxStore"
                            boxId="onTicketsBoxId"
                            expanded={stateExpanded}
                        />
                    ) : (
                        <div className="info-note">
                            <p>{i18n('onTicket.info.none')}</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default TournamentsOnTickets;
